import React, {useRef, useState, useEffect} from "react";
import {Link} from "react-router-dom";
import Lottie from "lottie-react";
import linesAnimation from "../animations/home-page-lines-layer.json";
import revolverAnimation from "../animations/menu-selection-revolver-standard.json";

export default function Menu({navItems, callback}) {
    let index = 0;
    const revolver = useRef();
    const [expandedMenuIndex, setExpandedMenuIndex] = useState(-1);

    const Rotate = function () {

        index++;
        if (index > 5) index = 0;

        if (index === 1) revolver.current.playSegments([0, 31], true);
        else if (index === 2) revolver.current.playSegments([31, 61], true);
        else if (index === 3) revolver.current.playSegments([61, 91], true);
        else if (index === 4) revolver.current.playSegments([91, 121], true);
        else if (index === 5) revolver.current.playSegments([121, 151], true);
        else if (index === 6) revolver.current.playSegments([151, 181], true);
        else if (index === 0) revolver.current.playSegments([181, 211], true);
    }

    useEffect(() => {
        setExpandedMenuIndex(-1);
    }, [navItems])
    

    return (
        <div className="relative w-full h-full overflow-visible">
            <div className="bg-gradient fixed inset-0"></div>
            <div className="hidden absolute left-0 w-full top-0 h-full lg:flex justify-center items-center">
                <Lottie
                    className="h-full w-auto scale-[2] opacity-25"
                    animationData={linesAnimation}
                    autoplay={true}
                    loop={true}
                />
            </div>
            <div className="hidden absolute left-0 w-full top-0 h-full lg:flex justify-center items-center">
                <Lottie
                    lottieRef={revolver}
                    className="h-full w-auto scale-[1.1]"
                    animationData={revolverAnimation}
                    autoplay={false}
                    loop={false}
                />
            </div>
            <div
                className="absolute left-0 w-full top-0 h-full flex flex-row justify-center items-start pt-16 lg:items-center">
                <div className="relative">
                    <div className={`flex flex-col space-y-6 lg:space-y-9 transition-all duration-500 ${expandedMenuIndex < 0 ? 'opacity-100 translate-x-0 pointer-events-auto' : 'opacity-0 -translate-x-full pointer-events-none'}`}>
                        {
                            navItems.map((navItem, itemIndex) => (
                                <div key={itemIndex} className='flex gap-1 align-middle items-center'>
                                    {!navItem.subMenu && <Link className="group flex flex-row space-x-8 items-center" to={navItem.url} onClick={callback} onMouseEnter={Rotate}>
                                            {navItem.icon()}
                                        <span className="flex-1 font-clarikageo font-demibold text-primary text-xl tracking-[6px] uppercase opacity-100 lg:opacity-60 lg:group-hover:opacity-100 transition-opacity text-left">
                                            {navItem.name}
                                        </span>
                                    </Link>}
                                    
                                    {
                                        navItem.subMenu && 
                                        <>
                                            <span className="cursor-pointer group flex flex-row space-x-8 items-center" onClick={()=> setExpandedMenuIndex(itemIndex)} onMouseEnter={Rotate}>
                                                    {navItem.icon()}
                                                <span className="flex-1 font-clarikageo font-demibold text-primary text-xl tracking-[6px] uppercase opacity-100 lg:opacity-60 lg:group-hover:opacity-100 transition-opacity text-left">
                                                    {navItem.name}
                                                </span>
                                                <span className='opacity-100 lg:opacity-60 lg:group-hover:opacity-100 transition-opacity mb-0.5 ml-4 cursor-pointer'>
                                                    <svg fill="#22206B" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.028 0v6.425l5.549 5.575-5.549 5.575v6.425l11.944-12z"/></svg>
                                                </span>
                                            </span>
                                        </>
                                    }
                                </div>)
                            )
                        }
                    </div>
                </div>
            </div>
            {
                <div className={`absolute inset-0 transition-all duration-500 ${expandedMenuIndex >= 0 ? 'opacity-100 translate-x-0 pointer-events-auto' : 'opacity-0 translate-x-full pointer-events-none'} flex flex-col space-y-6 lg:space-y-9 transition-all duration-500`}>
                    <div className='flex gap-4 mb-4 opacity-60 hover:opacity-100 w-fit justify-start cursor-pointer' onClick={()=> setExpandedMenuIndex(-1)}>
                        <svg className='rotate-180 mt-0.5' fill="#22206B" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.028 0v6.425l5.549 5.575-5.549 5.575v6.425l11.944-12z"/></svg>
                        <span className='flex-1 font-clarikageo font-demibold text-primary text-xl tracking-[6px] uppercase opacity-100 lg:opacity-60 lg:group-hover:opacity-100 transition-opacity text-left'>BACK</span>
                    </div>
                   {((navItems[expandedMenuIndex] && navItems[expandedMenuIndex].subMenu) || []).map((navItem, itemIndex) => (
                        <div key={itemIndex} className='flex gap-1 align-middle items-center'>
                            <Link className="group flex flex-row space-x-8 items-center" to={navItem.url} onClick={()=> { setExpandedMenuIndex(-1); callback(); }} onMouseEnter={Rotate}>
                                    {navItem.icon && navItem.icon()}
                                <span className="flex-1 font-clarikageo font-demibold text-primary text-xl tracking-[6px] uppercase opacity-100 lg:opacity-60 lg:group-hover:opacity-100 transition-opacity text-left">
                                    {navItem.name}
                                </span>
                            </Link>
                        </div>)
                    )}
                </div>
            }
        </div>
    );
}